// ApiFilters.js
import React, { useState, useEffect } from 'react';
import { Space, Row, Col } from 'antd';

import { ApiFilterCss } from './ApiFilters.style';

const ApiFilters = ({ apiFilters, checkedValues, handleCheckboxChange, handleApply, handleClearAll }) => {
  const [isFilterSelected, setIsFilterSelected] = useState(false);

  useEffect(() => {
    setIsFilterSelected(checkedValues.length > 0);
  }, [checkedValues]);

  return (
    <div css={ApiFilterCss} className="filterListContainer">
      {apiFilters.data.map((category, index) => (
        <div key={index}>
          <h3 className="sectionHeading" role="heading" aria-level="3">{category.heading}</h3>
          {
            category.filters.map((filter, filterIndex) => (
            <div key={filterIndex} className="filterTypes">
              <Space>
                <input
                  className="filter-checkbox"
                  style={{ marginRight: '10px' }}
                  type="checkbox"
                  id={`filter-${index}-${filterIndex}`}
                  checked={checkedValues.includes(filter.text)}
                  onChange={() => handleCheckboxChange(filter.text)}
                  aria-describedby={filter.count !== undefined ? `filter-count-${index}-${filterIndex}` : undefined}
                  aria-checked={checkedValues.includes(filter.text)}
                />
                <label htmlFor={`filter-${index}-${filterIndex}`} className="filter-label">
                  <span className="filter-text">{filter.text}</span>
                </label>
                {filter && filter.count !== undefined && (
                  <span 
                    className="filter-count" 
                    id={`filter-count-${index}-${filterIndex}`}
                    aria-label={`${filter.count} items available`}
                    style={{ marginLeft: '8px' }}
                  >
                    {filter.count}
                  </span>
                )}
              </Space>
            </div>
          ))}
        </div>
      ))}
      <div className="button-container">
      <button
          onClick={handleApply}
          className={`tell_us_button ${!isFilterSelected ? 'disabled-button' : ''}`}
          disabled={!isFilterSelected}
        >
          Apply
        </button>
      </div>
      <div className="link-container">
        <a 
          tabIndex={0} 
          onClick={handleClearAll} 
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleClearAll();
            }
          }}
          className="clear_all_button"
          role="button"
          aria-label="Clear all selected filters"
        >
          Clear All
        </a>
      </div>
    </div>
  );
};

export default ApiFilters;
